import Vue from 'vue';
import './plugins/vuetify.js';
import {FeatureFlagApp} from '@nuskin/ns-feature-flags-vue';
import {initI18n} from './i18n';
import {RunConfigService, init} from '@nuskin/ns-util';

import App from './App.vue';
import localSetup from './utils/localDev';
import * as acctComps from '@nuskin/account-components';

console.debug(`process.env.APP_IS_LOCAL: ${process.env.VUE_APP_IS_LOCAL}`);
const isLocal = (process.env.VUE_APP_IS_LOCAL && (process.env.VUE_APP_IS_LOCAL == 'true')) || false;
console.debug(`main.isLocal: ${isLocal}`);

/* istanbul ignore if */
if (process.env.VUE_APP_ENV_NAME) {
    acctComps.setDynamicImportEnv(process.env.VUE_APP_ENV_NAME);
} else {
    acctComps.setDynamicImportEnv({baseUrl: '/static/account-components/'});
}

window.__ns_test_enable_simulated_login = {
    localSetup
};

let runConfig = RunConfigService.getRunConfig();
// istanbul ignore else
if (!runConfig.baseUrl) {
    // istanbul ignore if
    init({baseUrl: isLocal ? 'http://localhost:8080' : null});
    runConfig = RunConfigService.getRunConfig();
}

const params = (new URL(window.location.href)).searchParams;
let locale = params.get('locale');
// istanbul ignore else
if (locale) {
    const localeParts = locale.split('_');
    const language = localeParts[0];
    const country = localeParts[1];
    console.debug('Updating RunConfig locale from URL', {country, language});

    // If we don't clear out the siteConfigurationPath, we can end up loading the wrong region's settings.
    RunConfigService.addRunConfig({country, language, siteConfigurationPath: undefined});
    runConfig = RunConfigService.getRunConfig();
} else {
    locale = `${runConfig.language}_${runConfig.country}`;
}

const i18n = initI18n(Vue, locale);

Vue.config.productionTip = false;

new Vue({
    i18n,
    render: (h) => h(FeatureFlagApp, [h(App)])
}).$mount('#app');
